var moment = require('moment-timezone');


export  default { 
     openInNewTab(url){
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
},

   diffTimes(t1, t2){
  var a = moment.unix(t1);
  var b = moment.unix(t2);
  var hours = moment.utc(b - a).format("hh,mm");
  var lessThenOneHour = false;
  // if (
  //   hours === "12" &&
  //   moment.unix(t1).format("l") === moment.unix(t2).format("l")
  // ) {
  //   lessThenOneHour = true;
  // }
  return lessThenOneHour === false ? `${hours}` : 0;
},
 unixToNormal (unixTime,date,time){
  return moment.unix(unixTime).tz('GMT+0').format((date && 'lll')||(time && 'HH:mm'))
},
getOptions(opt) {
  const firstDivOptions = [];
  const secondDivOptions = [];
  let options = opt ;
  var optionsNumber =opt ? Math.ceil(options.length / 2) : 0
  if (opt) {
    for (let i = 0; i < optionsNumber; i++) {
      firstDivOptions.push(options[i].replaceAll('+'," "));
    }
    for (let i = optionsNumber; i < options.length; i++) {
      secondDivOptions.push(options[i].replaceAll('+'," "));
    }
  }
  return { firstDivOptions, secondDivOptions };
}
}


